import { gql } from "@apollo/client";

const GET_ARCHIVO_REMITO = gql`
    query archivoRemito($remito: String!) {
        archivoRemito(remito: $remito) {
            success
            error
            valorEsperado{
                archivo
                titulo
                extension
                contentType
            }
        }
    }
`;

export default GET_ARCHIVO_REMITO;